/** Collision-resistant ids without pulling in a uuid dependency. */
export function createId(prefix = 'id') {
    const rand = typeof crypto !== 'undefined' && 'randomUUID' in crypto
        ? crypto.randomUUID().replace(/-/g, '').slice(0, 12)
        : Math.random().toString(36).slice(2, 14);
    return `${prefix}_${Date.now().toString(36)}${rand}`;
}
